<div class="nipr-alerts-block">
  <div class="dash-nipr-block">
    <div class="p-0">
      <div class="tab common-tab p-0 widget-tab" role="tabpanel">
        <div class="tab-content">
          <div class="activity-log"
               style="height:257px; overflow-y:auto;"
               (scroll)="onScroll($event)">
            <div class="audit-log-table">
              <table *ngIf="activities?.length > 0">
                <thead class="sticky-table-header">
                  <tr class="audit-log-header">
                    <th scope="col">Activity</th>
                    <th scope="col" width="180">By</th>
                    <th scope="col" width="150">On</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="audit-log-list" *ngFor="let activity of activities">
                    <td><span class="max-width-tooltip-450" appEllipsifyMe>{{activity.description}}</span></td>
                    <td><span class="max-width-tooltip-165" appEllipsifyMe>{{activity.createdByName}}</span></td>
                    <td>{{activity.createdDate | date :'MM/dd/yyyy hh:mm a'}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="common-loader mt-5" [hidden]="!showLoader" style="position: relative;">
                <div class="loader-icon mt-5">
                  <img src="assets/images/common-loader.gif" alt="">
                </div>
              </div>
              <div class="no-data-found p-0" *ngIf="activeList && activities?.length <= 0">
                <!-- <app-no-data-found [isGraphDashboard]="'false_false_ _ _There are no activity logs found'"></app-no-data-found>
               -->
              <div class="no-data-found">
                  <img [ngClass]="{'dashboard-img': true}" src="../../../../assets/images/no-data.svg" >
                  <h5>No activity records found</h5>
                  <div class="margin-block"><a href="" class="link-modal"></a> 
                      Logged activity history will be shown here when available.</div>
              </div>
              
              </div>
            </div>
            <!-- <div class="no-data-found p-0" *ngIf="activeList && activities?.length <= 0">
              <app-no-data-found [isGraphDashboard]="'false_false_ _ _There are no activity logs found'"></app-no-data-found>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
